import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFirestore } from "angularfire2/firestore";

@Injectable()
export class TaskProvider {

  constructor(
    private afs: AngularFirestore
  ) {}

  listTasksByProgram(program_id)  {
    return this.afs.collection<any>(`program/${program_id}/tasks`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }

  listTasksByPatient(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/task_history`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }

  getTask(program_id: string, task_id: string) {
    return this.afs.collection<any>(`program/${program_id}/tasks/${task_id}`);
  }

  addTask(program_id: string, patient_id: string, task: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    const completed = false;
    task = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, completed, ...task };
    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/tasks`).doc(doc_id).ref, task);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/task_history`).doc(doc_id).ref, task);
    return batch.commit();
  }

  updateTask(program_id: string, patient_id: string, task_id: string, task: any, user: any)  {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedBy = user;
    task = { updatedAt, updatedBy, ...task };
    var batch = this.afs.firestore.batch();
    batch.update(this.afs.collection<any>(`program/${program_id}/tasks`).doc(task_id).ref, task);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/task_history`).doc(task_id).ref, task);
    return batch.commit();
  }

  deleteTask(program_id: string, patient_id: string, task_id: string)  {
    var batch = this.afs.firestore.batch();
    batch.delete(this.afs.collection<any>(`program/${program_id}/tasks`).doc(task_id).ref);
    batch.delete(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/task_history`).doc(task_id).ref);
    return batch.commit();
  }
}


// WEBPACK FOOTER //
// ./src/providers/task/task.ts